import React, { useState, useEffect } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Building2,
  MapPin,
  ArrowLeft,
  Save,
  X,
  PlusCircle,
  Layout,
  Info
} from "lucide-react";
import { Formik, Form, Field } from "formik";
import { addSite, getAllSites, getAllLocations } from "../../store/actions";
import {
  Button,
  Input,
  Select,
  Tabs,
  Breadcrumb,
  useToast,
  Card
} from "../UI";
import { axiosConfig } from "../../config/index";
import { SiteValidationSchema } from "../../validations/index";

const AddSite = ({ addSite, history }: any) => {
  const { toast } = useToast();
  const [locationItems, setLocationItems] = useState<any>([]);

  useEffect(() => {
    axios.get(`/api/sites/getalllocation/`, axiosConfig)
      .then((response: any) => {
        setLocationItems(response.data);
      })
      .catch((err: any) => console.error(err));
  }, []);

  const locationOptions = locationItems.map((op: any) => ({
    label: op.location,
    value: op.location
  }));

  const tabs = [
    {
      id: 'details',
      icon: <Info className="w-4 h-4" />,
      content: (
        <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-500">
          <div className="grid grid-cols-1 md:grid-cols-1 gap-8 max-w-sm">
            <div className="space-y-6">
              <Field name="sitename">
                {({ field, form, meta }: any) => (
                  <Input
                    {...field}
                    label="Site Name"
                    placeholder="e.g. HQ"
                    error={meta.touched && meta.error ? meta.error : ""}
                    required
                  />
                )}
              </Field>
            </div>

            <div className="space-y-6">
              <Field name="region">
                {({ field, form, meta }: any) => (
                  <Select
                    label="Location / Region"
                    placeholder="Select a location..."
                    options={locationOptions}
                    value={field.value}
                    onChange={(val) => form.setFieldValue("region", val)}
                    error={meta.touched && meta.error ? meta.error : ""}
                    searchable
                    required
                  />
                )}
              </Field>


            </div>
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="max-w-md space-y-5">
      <div className="flex flex-col gap-2">
        <Breadcrumb
          items={[
            { label: 'Home', to: '/dashboard' },
            { label: 'Sites', to: '/sitelist' },
            { label: 'Add Site' }
          ]}
        />

        <div className="flex items-center justify-between">
          <div className="flex items-left gap-2.5">
            <div className="w-9 h-9 bg-[#8dc63f]/15 rounded-xl flex items-center justify-center">
              <PlusCircle className="w-4 h-4 text-[#8dc63f]" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 tracking-tight leading-none">New Site</h1>
          </div>

          <Link to="/sitelist">
            <Button variant="ghost" size="sm" className="h-8 px-3 gap-1.5 text-xs text-slate-400 hover:text-slate-900">
              <ArrowLeft className="w-3.5 h-3.5" />
              Back
            </Button>
          </Link>
        </div>
      </div>

      <Formik
        initialValues={{
          sitename: "",
          region: "",
        }}
        validationSchema={SiteValidationSchema}
        onSubmit={async (values, { setErrors, resetForm, setSubmitting }) => {
          try {
            await addSite(values);
            toast("Site created successfully", "success");
            resetForm({});
            history.push("/sitelist");
          } catch (error: any) {
            toast(error.message || "Failed to create site", "error");
            setErrors(error);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit} className="space-y-8">
            <Card>
              {tabs[0].content}
            </Card>

            <div className="flex items-center justify-end gap-3 pt-4 px-1">
              <Link to="/sitelist">
                <Button type="button" variant="ghost" size="sm" className="h-8 px-4 text-xs">Cancel</Button>
              </Link>
              <Button
                type="submit"
                className="h-10 px-10 gap-2 shadow-xl shadow-[#8dc63f]/20 bg-[#8dc63f] hover:bg-[#76ab32]m"
                disabled={isSubmitting}
              >
                <Save className="w-3.5 h-3.5" />
                {isSubmitting ? 'Registering...' : 'Register Site'}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.auth.user,
});

const mapDispatchToProps = {
  getAllSites,
  addSite,
  getAllLocations,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddSite);



